export const colors = {
  volcano: ["#FF7A45", "#FF9C6E", "#FFD8BF"],
  green: ["#52C41A", "#95DE64", "#B7EB8F"],
  blue: ["#40A9FF", "#69C0FF", "#BAE7FF"],
  red: ["#FF7875", "#FFA39E", "#FFCCC7"],
  magenta: ["#FF85C0", "#FFADD2", "#FFD6E7"],
  orange: ["#FA8C16", "#FFC069", "#FFD591"],
  gold: ["#FAAD14", "#FFD666", "#FFE58F"],
  cyan: ["#13C2C2", "#5CDBD3", "#B5F5EC"],
  geekBlue: ["#85A5FF", "#ADC6FF", "#D6E4FF"],
  purple: ["#B37FEB", "#D3ADF7", "#EFDBFF"],
  style2: ["#69C0FF", "#85A5FF", "#5CDBD3"],
};

const machineCardThemes = [
  colors.volcano,
  colors.green,
  colors.blue,
  colors.red,
  colors.magenta,
  colors.orange,
  colors.gold,
  colors.cyan,
  colors.geekBlue,
  colors.purple,
  colors.style2,
];
export const machineCardTheme = new Array(100).fill(machineCardThemes).flat();

const donutColorTheme = [
  colors.volcano[1],
  colors.green[1],
  colors.blue[1],
  colors.red[1],
  colors.magenta[1],
  colors.orange[1],
  colors.gold[1],
  colors.cyan[1],
  colors.geekBlue[1],
  colors.purple[1],
];
export const donutColors = new Array(100).fill(donutColorTheme).flat();

export const freePropertyTitleColors = [machineCardTheme[0][1], machineCardTheme[1][1], machineCardTheme[2][1]];
